import Modal from 'root/module/modal';
export default Object.assign({}, Modal);